@if (show()) {
  @defer (when show()) {
    <iza-bubble />
  } @error {
    <!-- falha ao carregar o chunk da bubble: Otimiza segue normal -->
  }
}
